import useSWR from 'swr';

import myShopClient from '@services/nearlive';

/**
 * SWR-backed channel list for `shopId`. Returns whatever the API resolves
 * with — there is no frontend fallback. Pages should render their empty /
 * loading state when `channels.length === 0` and rely on the seeded shop
 * in the dev environment to populate the catalogue.
 */
export function useChannels(shopId) {
	const key = shopId ? ['unify:channels', shopId] : null;
	const { data, error, isLoading, mutate } = useSWR(
		key,
		async () => {
			const client = await myShopClient();
			const { data } = await client.get(`/api/channels/${shopId}`);
			return data;
		},
		{ revalidateOnFocus: false }
	);
	return { channels: Array.isArray(data) ? data : [], error, isLoading, mutate };
}
